<template>
  <div class="accordion">
    <slot />
  </div>
</template>

<script>
export default {
  props: {},
  data () {
    return {
      AccordionGroup: {
        count: 0,
        active: null
      }
    }
  },
  provide () {
    return { AccordionGroup: this.AccordionGroup }
  }
}
</script>
